import { useState, useEffect, useCallback } from 'react';
import { CompanyValuesInput } from './CompanyValuesInput';
import { useSelector } from 'react-redux';
// import useJdGenerator from '../../Hooks//useJdGenerator';
import crossIcon from '../../Assets/closeIcon.svg';
import uploadIcon from '../../Assets/uploadIconBlack.svg';
// import useUploadResumeForMockInterview from '../../Hooks/mockInterview/useUploadResumeForMockInterview';
import { MockInterviewContext } from '../../Contexts/mockInterviewContext.js'
import { Loader } from '../../constents/components.js';
import { useNewMockCreate } from '../../Hooks/mockInterview/useNewMockCreate.js';
import { useNavigate } from 'react-router-dom';
import { CompanySkillsInput } from './CompanySkillsInput.jsx';
import { GET_MOCK_PLAN } from '../../Utils/apis.js';

const MockTokenChecker = ({ children }) => {
    // const mockInterviewId = useSelector(store => store?.currentMockInterviewId);
    // const Navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const respose = await fetch(GET_MOCK_PLAN, {
                    method: 'GET',
                    credentials: 'include',
                });

                if (!respose.ok) {
                    throw new Error('No active plan');
                }
                setSuccess(true);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return success ? children : loading ? (<div className=' w-full min-h-20 flex  justify-center items-center'>
        <Loader />
    </div>) : (<div className=" mx-auto w-full flex justify-center">No active plan found. visit <span onClick={() => navigate('/mock/plans')} className="text-blue-500 mx-1 cursor-pointer hover:underline">plans</span> page to buy</div>);
};

export const JobTitleInput = ({ input = '', setInput, jobs }) => {
    const uniqueTitles = [...new Set(jobs)];
    const [showList, setShowList] = useState(false);
    
    useEffect(() => {
        setShowList(input.length > 0);
    }, [input]);

    // Enhanced filtering: prioritize startsWith, then includes
    const startsWithMatches = uniqueTitles.filter(item => 
        item.toLowerCase().startsWith(input.toLowerCase())
    );
    const includesMatches = uniqueTitles.filter(item => 
        item.toLowerCase().includes(input.toLowerCase()) && 
        !item.toLowerCase().startsWith(input.toLowerCase())
    );
    const filteredList = [...startsWithMatches, ...includesMatches].slice(0, 10);
    
    const hasExactMatch = uniqueTitles.some(item => 
        item.toLowerCase() === input.toLowerCase()
    );

    const needToShow = () => {
        if (input.length < 1) return false;
        if (filteredList.length === 1 && hasExactMatch) return false;
        return showList;
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            setShowList(false);
        }
    };

    const selectOption = (value) => {
        setInput(value);
        setShowList(false);
    };

    return (
        <div>
            <label className="block text-sm font-medium mb-2">
                Select the Job Title which you want to evaluate yourself for (Press Enter If typing custom title)
            </label>
            <div className='relative'>
                <input
                    type="text"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={handleKeyDown}
                    className='w-full p-2 border rounded-xl outline-none'
                />
                {needToShow() && (
                    <ul className=' absolute top-[110%] bg-white  max-h-72 overflow-auto w-full p-2 border-[2px]  z-10 '>
                        {filteredList.map((item, index) => (
                            <li
                                className=' cursor-pointer hover:bg-gray-100 p-[.4rem]'
                                onClick={() => selectOption(item)}
                                key={index}
                            >
                                {item}
                            </li>
                        ))}
                        {!hasExactMatch && input.trim() && (
                            <li
                                className=' cursor-pointer  hover:bg-gray-100 p-[.4rem] text-black border-t border-gray-200'
                                onClick={() => selectOption(input.trim())}
                            >
                                Use "{input.trim()}" as custom input
                            </li>
                        )}
                    </ul>
                )}
            </div>
        </div>
    );
};

const NewMock = () => {
    const WORK_EX_LIST = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25];
    const COMPANY_VALUES = ['integrity', 'ethics', 'teamwork', 'innovation', 'diversity', 'inclusion', 'collaboration', 'excellence', 'accountability'];
    const industries = useSelector(store => store?.industries);
    const Question_Preference = ["easy", "medium", "hard"];
    // const { currentMockId, setCurrentMockId } = useContext(MockInterviewContext);
    const [creating, createError, submitMock] = useNewMockCreate();
    const [resumeInputKey, setResumeInputKey] = useState(Date.now());
    const [selectedSkills, setSelectedSkills] = useState([]);
    const Navigate = useNavigate();

    const [state, setState] = useState({
        resume: null,
        job_industry: '',
        title: '',
        // description: '',
        experience: 0,
        question_preference: 'easy',
        values: [],
        skills: [],
    });
    // console.log(industries);
    useEffect(() => {
        if (!state?.job_industry) {
            setState((prevState) => ({
                ...prevState,
                job_industry: Object?.keys(industries).length > 0 ? Object?.keys(industries)[0] : '',
                title: ''
            }));
        }
    }, [industries]);
    // console.log(state);

    const [error, setError] = useState(null);

    const validateForm = useCallback(() => {
        if (!state.resume) {
            setError('Resume is required');
            return false;
        }
        if (!state.title || state.title.trim() === '') {
            setError('Title is required');
            return false;
        }
        if (state.values.length !== 2) {
            setError('Please select exactly 2 personal values');
            return false;
        }
        if (state.skills.length !== 3 ) {
            setError('Please select exactly 3 skills');
            return false;
        }
        if (isNaN(state.experience) || state.experience < 0) {
            setError('Experience must be a valid number');
            return false;
        }
        setError(null);
        return true;
    }, [state]);

    // Real-time validation as user fills the form
    useEffect(() => {
        validateForm();
    }, [validateForm]);


    const handleChange = (e) => {
        const { name, value } = e.target;

        // Convert experience to number
        const processedValue = name === 'experience' ? parseInt(value, 10) : value;
        const updated = { ...state, [name]: processedValue };

        setState(updated);

        if (!updated.title || updated.title.trim() === '') {
            setError('Title is required');
        } else if (updated.values.length !== 2) {
            setError('Please select exactly 2 personal values');
        } else if (updated.skills.length !== 3) {
            setError('Please select exactly 3 skills');
        } else if (isNaN(updated.experience) || updated.experience < 0) {
            setError('Experience must be a valid number');
        } else {
            setError(null);
        }

    };

    // console.log(error);
    // console.log("this is the state", state);

    // const [jdLoading, jdError, jd, fetchJd] = useJdGenerator();

    // useEffect(() => {
    //     if (jd) {
    //         handleChange({ target: { name: 'description', value: jd } });
    //     }
    // }, [jd]);

    const [skillInput, setSkillInput] = useState('');
    const addSkill = () => {
        if (!state.skills.includes(skillInput) && state.skills.length < 3) {
            handleChange({ target: { name: 'skills', value: [...state.skills, skillInput] } });
        }
        setSkillInput('');
    }
    const removeSkill = (skill) => {
        handleChange({ target: { name: 'skills', value: state.skills.filter((item) => item !== skill) } });
        setSkillInput('');
    }


    const handleSubmit = async () => {
        if (!validateForm()) return;
        try {
            const formData = new FormData();
            formData.append('resume', state.resume);
            formData.append('title', state.title);
            formData.append('job_industry', state.job_industry);
            formData.append('experience', state.experience);
            formData.append('question_preference', state.question_preference);
            formData.append('values', JSON.stringify(state.values));
            formData.append('skills', JSON.stringify(state.skills));
            // Add other fields as needed
            // console.log("FormData to be submitted:", formData);
            await submitMock(formData);
            alert('Your mock interview will be created in 2 min , check mock page after 2 min for updates');
            Navigate('/mock/');
        } catch (e) {
            alert('Creating mock interview failed , try again ');
        }
    }
    // const [mockResumeLoading, _, mockInterviewId, mockResumeUploader] = useUploadResumeForMockInterview({ onSuccess: (id) => setCurrentMockId(id) });

    if (createError) {
        if (createError === "Sorry You do not have any active plans right now") {
            return (<div className=" mx-auto w-full flex justify-center">
                <div className="bg-white m-2 p-6 rounded-xl border w-full md:w-[70%] lg:w-[50%] flex flex-col gap-6">
                    <h4>Sorry You do not have any active plans right now</h4>
                    <p> please <span onClick={() => Navigate('/mock/plans')} className=' underline text-blue-800'>buy</span> interview plans before submiting</p>
                </div>
            </div>)
        }
    }
    // console.log("what we have in indudtry", industries)
    // console.log("kya error aa rhi he lalla", error);
    return <MockTokenChecker>{creating ?
        (<div className=' w-full min-h-20 flex  justify-center items-center'>
            <Loader />
        </div>) : (
            <div className=" mx-auto w-full flex justify-center">
                {/* Left Column */}
                <div className="bg-white m-2 p-6 rounded-xl border w-full md:w-[70%] lg:w-[50%] flex flex-col gap-6">
                    {/* upload resume */}
                    {
                        // mockResumeLoading ?
                        //     <div className=' w-full min-h-20 flex  justify-center items-center'>
                        //         <Loader />
                        //     </div>
                        //     : currentMockId ? (
                        //         <div className=' w-full flex items-center'>
                        //             <p className='text-primary-color-900 font-semibold'>Resume uploaded successfully</p>
                        //         </div>)
                        //         :
                        (
                            <div>
                                <label className="block text-sm font-medium mb-2">Upload Your CV(pdf/word)</label>
                                <div 
                                    className=' border-2 border-dashed border-orange-500 rounded-lg p-6 text-center flex flex-col items-center'
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={(e) => {
                                        e.preventDefault();
                                        const file = e.dataTransfer.files[0];
                                        if (file && (file.type === 'application/pdf' || file.type.includes('document'))) {
                                            setState(prev => ({ ...prev, resume: file }));
                                        }
                                    }}
                                >
                                    <input
                                        key={resumeInputKey}
                                        type="file"
                                        id="talentUploadButtonLabel"
                                        className="hidden"
                                        accept=".pdf , .doc, .docx"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            setState(prev => ({ ...prev, resume: file }));
                                        }}
                                    />
                                    <label
                                        htmlFor="talentUploadButtonLabel"
                                        className="flex cursor-pointer w-full flex-col items-center"
                                    >
                                        <div className="w-12 h-12 flex items-center justify-center bg-gray-200 rounded-full ">
                                            <img src={uploadIcon} className="w-6 h-6" alt="uploadIcon" />
                                        </div>
                                        <div className="text-center">
                                            <p className="text-gray-500 text-sm mt-2">Drag & drop or click to upload</p>
                                            <p className="text-gray-500 text-sm">Supported pdf/doc/docx</p>
                                        </div>
                                    </label>
                                    {state.resume && (
                                        <div className="mt-2 flex items-center gap-2">
                                            <span className="text-sm text-green-700">{state.resume.name}</span>
                                            <button
                                                className="text-xs text-red-500 underline"
                                                onClick={() => {
                                                    setState(prev => ({ ...prev, resume: null }))
                                                    setResumeInputKey(Date.now());
                                                }}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )
                    }


                    {/* Job Industry */}
                    <div>
                        <label className="block text-sm font-medium mb-2">Select Your Interested Industry</label>
                        <select
                            name='job_industry'
                            className="w-full p-2 border rounded-xl outline-none"
                            onChange={handleChange}
                        >
                            {Object.keys(industries)?.map((item, index) => (
                                <option key={index} value={item}>{item}</option>
                            ))}
                        </select>
                    </div>
                    {/* Title */}
                    <JobTitleInput
                        input={state.title}
                        setInput={(value) => setState(prev => ({ ...prev, title: value }))}
                        jobs={industries?.[state?.job_industry] || []}
                    />
                    {/* Work Experience */}
                    <div>
                        <label className="block text-sm font-medium mb-2">Work Experience</label>
                        <select
                            className="w-full p-2 border rounded-xl outline-none"
                            onChange={handleChange}
                            name='experience'
                        >
                            {WORK_EX_LIST?.map((item, index) => (
                                <option key={index}>{item}</option>
                            ))}
                        </select>
                    </div>
                    {/* Difficulty */}
                    <div>
                        <label className="block text-sm font-medium mb-2">Difficulty</label>
                        <select
                            className="w-full p-2 border rounded-xl outline-none"
                            onChange={handleChange}
                            name='question_preference'
                        >
                            {Question_Preference?.map((item, index) => (
                                <option key={index}>{item}</option>
                            ))}
                        </select>
                    </div>

                    {/* Skills */}
                    <CompanySkillsInput
                        selectedSkills={state.skills}
                        setSelectedSkills={(skills) => setState(prev => ({ ...prev, skills }))}
                    />


                    {/* Company Values */}
                    <CompanyValuesInput
                        selectedValues={state.values}
                        setSelectedValues={(values) => setState(prev => ({ ...prev, values }))}
                        values={COMPANY_VALUES}
                    />

                    <div className='flex justify-end mt-2'>
                        <button
                            className={`bg-primary-color-900 text-white text-md px-4 py-1 rounded-lg ${error ? 'opacity-50 cursor-not-allowed' : ''}`}
                            onClick={() => {
                                // Always validate before submit
                                if (!validateForm()) return;
                                if (!error) {
                                    const confirmed = window.confirm('Are you sure to submit? This will deduct 1 token.');
                                    if (confirmed) {
                                        handleSubmit();
                                    }
                                }
                            }}
                        >
                            {creating ? 'Submitting' : `Ready? Let's go!`}
                        </button>
                    </div>

                </div>
            </div>

        )}</MockTokenChecker >
}



export default NewMock;
